import { DeviceModel } from "../../../models/DeviceModel";
import { DEVICE_CHANGED } from "../../actions";
import { ActionTypes } from "../../actions/types";

export const deviceSliceReducer = (state: DeviceModel, action: ActionTypes) => {
    switch (action.type) {
        case DEVICE_CHANGED:
            return action.device;
        default:
            return state;
    }
};
